import styled from 'styled-components';

export const ChartContainerStyled = styled.div`
  height: 100% !important;

  svg text[id^="charts_Series"] {
    transform: translateY(-20px);
  }

`;